module.exports = __webpack_public_path__ + "img/icon-window.4a85a479.svg";